var render = function () {
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.menu] = true, _class[_vm.$style.white] = _vm.settings.menuColor === 'white', _class[_vm.$style.gray] = _vm.settings.menuColor === 'gray', _class[_vm.$style.dark] = _vm.settings.menuColor === 'dark', _class)
  }, [_c('div', {
    class: _vm.$style.logoContainer
  }, [_c('div', {
    class: _vm.$style.logo
  }, [_c('img', {
    staticClass: "mr-2",
    attrs: {
      "src": "/resources/images/logo.png"
    }
  }), _c('div', {
    class: _vm.$style.name
  }, [_vm._v(_vm._s(_vm.settings.logo))])])]), _c('div', {
    class: _vm.$style.navigation
  }, [_c('a-menu', {
    attrs: {
      "mode": 'horizontal',
      "selectedKeys": _vm.selectedKeys
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm._l(_vm.menuData, function (item) {
    return [!item.roles || item.roles.includes(_vm.user.role) ? [!item.children && !item.category ? _c('item', {
      key: item.key,
      attrs: {
        "menu-info": item,
        "styles": _vm.$style
      }
    }) : _vm._e(), item.children ? _c('sub-menu', {
      key: item.key,
      attrs: {
        "menu-info": item,
        "styles": _vm.$style
      }
    }) : _vm._e()] : _vm._e()];
  })], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }